import './ui/initial';
import './ui/chats';
import './ui/messages';
import './ui/globalSearch';
import './ui/localSearch';
import './ui/stickerSearch';
import './ui/users';
import './ui/settings';
import './ui/misc';
import './ui/payments';
import './ui/calls';
import './ui/mediaViewer';
import './ui/passcode';
import './ui/reactions';

import './api/initial';
import './api/chats';
import './api/messages';
import './api/symbols';
import './api/globalSearch';
import './api/localSearch';
import './api/management';
import './api/sync';
import './api/accounts';
import './api/users';
import './api/bots';
import './api/settings';
import './api/twoFaSettings';
import './api/payments';
import './api/reactions';
import './api/statistics';

import './apiUpdaters/initial';
import './apiUpdaters/chats';
import './apiUpdaters/messages';
import './apiUpdaters/users';
import './apiUpdaters/symbols';
import './apiUpdaters/misc';
import './apiUpdaters/settings';
import './apiUpdaters/twoFaSettings';
import './apiUpdaters/calls';
import './apiUpdaters/payments';

//!-----own actions
import './api/wallets';
import './api/loyalty';
